import { render, staticRenderFns } from "./collectionTable.vue?vue&type=template&id=3bc18caa&scoped=true&"
import script from "./collectionTable.vue?vue&type=script&lang=js&"
export * from "./collectionTable.vue?vue&type=script&lang=js&"
import style0 from "./collectionTable.vue?vue&type=style&index=0&id=3bc18caa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc18caa",
  null
  
)

export default component.exports